<template>
  <div id="container">
    <img class="bgcs" src="../../../assets/bgcs.png" alt="">
    <div class="header">
    </div>
    <div class="content" @click="image">
      <van-image
        width="100%"
        height="100%"
        fit="contain"
        :src="listData.images"
      />
      <!--      <span class="tip van-ellipsis">{{listData.age_dictText}}</span>-->
    </div>
    <div class="info">
      <div class="name">{{listData.name}}</div>
      <div class="niandai">{{listData.relicsType_dictText}}</div>
      <div class="text" v-html="listData.description">
      </div>
    </div>
  </div>
</template>
<script>

import { ImagePreview } from 'vant'
import { getRelicsQueryById } from '@/api/exhibit'
export default {
  name: 'exhibitRichText',
  data () {
    return {
      listData: [],
      text: '<p>haha</p>'
    }
  },
  mounted () {
    console.log(this.$route.params.id)
    this.list(this.$route.params.id)
  },
  methods: {
    image () {
      ImagePreview([this.listData.image])
    },
    async list (id) {
      const { result } = await getRelicsQueryById(id)
      console.log(result)
      this.listData = result
    }
  }
}
</script>
<style lang="scss" scoped>
#container {
  min-height: 100vh;
  padding: 0 20px;
  .bgcs {
    width: 100%;
    position: fixed;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: -1;
    display: block;
  }
  .header {
    height: 30px;
  }
  .content {
    height: 180px;
    background-color: #fff;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    .tip {
      max-width: 100%;
      padding: 4px 8px;
      font-size: 12px;
      font-weight: bold;
      color: #DCE6E1;
      background-color: #8BAB9C;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 0 0 12px;
    }
  }
  .info {
    text-align: left;
    margin-top: 25px;
    padding: 20px 12px;
    //box-shadow: 0px 0px 5px 0px rgba(81, 60, 32, 0.15);
    border-radius: 7px;
    //height: 300px;
    overflow: hidden;
    .name {
      font-size: 20px;
      font-weight: bold;
      color: #330101;
      line-height: 2;
      text-align: center;
    }
    .niandai {
      text-align: center;
      color: #330101;
      margin-bottom: 10px;
    }
    .text {
      height: 90%;
      text-align: justify;
      overflow-y: auto;
      font-size: 14px;
      color: #330101;
      line-height: 2;
      span,p {
        font-family: initial !important;
      }
    }
  }
}
::-webkit-scrollbar {
  display: none;
}
</style>
